/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter, applyFilters } from '@wordpress/hooks';
import { RangeControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import testimonialBlockInfo from '../testimonial/constants';
import blockInfo from '../constants';
import BlockLayouts from '../../../components/block-layouts';
const { hookPrefix } = blockInfo;
const { layouts } = testimonialBlockInfo;

addFilter( `gutenify-block-${ hookPrefix }-options-tab-content`, `Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'testimonials',
						initialOpen: true,
						label: () => {
							return __( 'Testimonials' );
						},
						cb: () => {
							return <>
								{ applyFilters( `gutenify--${ hookPrefix }--inspector--tab-content--posts`, [], props ) }
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);

addFilter( `gutenify--${ hookPrefix }--inspector--tab-content--posts`, `gutenify--${ hookPrefix }--inspector--tab-content--posts--post-layout`, ( content, props ) => {
	const { attributes, setAttributes, updateInnerBlocks } = props;
	const { layout } = attributes;
	return [ ...content, <Fragment key={ `gutenify--${ hookPrefix }--inspector--tab-content--posts--post-layout` }>
		<BlockLayouts label={ __( 'Layout' ) } layouts={ layouts } value={ layout } blockName={ hookPrefix } onChange={ ( val ) => {
			const data = {
				layout: val.name,
				ratingAlign: val.ratingAlign,
				imageAlign: val.imageAlign,
				titleAlign: val.titleAlign,
			};
			setAttributes( data );
			updateInnerBlocks( val );
		} } />
	</Fragment> ];
} );

addFilter( `gutenify--${ hookPrefix }--inspector--tab-content--posts`, `gutenify--${ hookPrefix }--inspector--tab-content--posts--columns`, ( content, props ) => {
	const { attributes, setAttributes } = props;
	const { columnSize } = attributes;
	return [ ...content, <Fragment key={ `gutenify--${ hookPrefix }--inspector--tab-content--posts--columns` }>
		<RangeControl value={ columnSize } label={ __( 'Columns' ) } min={ 1 } max={ applyFilters( `gutenify--${ hookPrefix }--max-columns`, 4 ) } step={ 1 } onChange={ ( value ) => {
			setAttributes( { columnSize: value } );
		} } />
	</Fragment> ];
} );
